import React, {Component} from 'react';
import {Store} from 'app/store';
import ShopItems from './lootboxes/shop_items';
import InnerTabs from 'app/components/InnerTabs';
import I18n from 'app/i18n';
import {goToRoute} from 'app/utils/link_helper';
import {isUSD} from 'app/utils/ShopItemPriceFormat';
import {ShopItemsGamesInterface} from 'app/store/ShopStore';
import ShopItemInterface from 'app/interfaces/shop/ShopItemInterface';
import {ShopTableInterface} from 'app/interfaces/ShopTableInterface';
import withRouter, {withRouterInterface} from 'app/utils/navigate/customWithRouter';
import {inject, observer} from 'mobx-react';
import SelectPicker from 'app/components/reusable/SelectPicker';
import CollectionInterface from 'app/interfaces/CollectionInterface';

interface GameTab {
    query: {game: string, currency: string};
    title: string;
}

const ALL_GAMES = 'all';
const updateShop = (): void => Store.updateShop();

interface ShopTableState {
    currency: string,
    game: string
}

class ShopTableLootboxes extends Component<ShopTableInterface, ShopTableState> {
    state = {
        currency: '',
        game: ALL_GAMES
    };

    get newCurrencies() {
        return [{text: 'USD', value: 'usd'}, {text: I18n.t('user_points'), value: 'points'}];
    }

    get currencies() {
        return this.newCurrencies.map((currency): CollectionInterface => ({
            text: currency.text,
            value: currency.value
        }));
    }

    get currency() {
        const {currency} = this.props.shopStore.last_lootbox_filter;
        return new URLSearchParams(location.search).get('currency') || currency;
    }

    get params_game() {
        return new URLSearchParams(location.search).get('game');
    }

    constructor(props: ShopTableInterface) {
        super(props);

        this.state = {
            currency: this.currency || 'usd',
            game: this.defaultGame(this.params_game)
        };
    }

    isValidGame(game: string | null): game is string {
        if (game === null) {
            return false;
        }

        return game === ALL_GAMES || this.gameKeys.includes(game);
    }

    defaultGame(default_game: string | null): string {
        const {game} = this.props.shopStore.last_lootbox_filter;

        if (this.isValidGame(default_game)) {
            return default_game;
        }

        return this.isValidGame(game) ? game : ALL_GAMES;
    }

    handleChangeGame = (game: string): void => {
        this.setState({game});
        this.props.shopStore.setLastLootboxTab({currency: this.state.currency, game});
    };

    handleChangeCurrency = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        const currency = e.target.value;
        this.setState({currency});
        const {location: {pathname}} = this.props as ShopTableInterface & withRouterInterface;
        goToRoute(`${pathname}?currency=${currency || ''}&game=${this.state.game || ''}`);
        this.props.shopStore.setLastLootboxTab({currency, game: this.state.game});
    };

    changeNameFilter = (key: string): string => {
        if (key === '') {
            return I18n.t('new_lootboxes_header_shop');
        } else if (key === 'Casino') {
            return I18n.t('casino_lootboxes_header_shop');
        }

        return key;
    };

    get items(): ShopItemsGamesInterface {
        return this.props.shopStore.data.lootboxes;
    }

    get gameKeys(): string[] {
        return Object.keys(this.items).sort((a, b) => a.localeCompare(b));
    }

    getItemsWithGame = (): Array<ShopItemInterface & {game?: string}> => {
        if (this.state.game === ALL_GAMES) {
            return this.gameKeys.reduce(
                (items: Array<ShopItemInterface & {game?: string}>, game: string) => items.concat(
                    this.getItems(game).map(item => ({...item, game}))
                ),
                []
            );
        }

        return this.getItems(this.state.game).map(item => ({...item, game: this.state.game}));
    };

    get allItemsCount(): number {
        return this.gameKeys.reduce((count: number, game: string) => count + this.getItems(game).length, 0);
    }

    get game_tabs(): GameTab[] {
        const gameTabs = this.gameKeys.map(key => ({
            query: {
                currency: this.state.currency,
                game: key
            },
            title: `${this.changeNameFilter(key)} (${this.getItems(key).length})`
        }));

        return [
            {
                query: {
                    currency: this.state.currency,
                    game: ALL_GAMES
                },
                title: `${I18n.t('all')} (${this.allItemsCount})`
            }, ...gameTabs
        ];
    }

    getItems = (game: string): ShopItemInterface[] => this.items[game]
        ? this.items[game].filter(item => item[isUSD(this.state.currency) ? 'cost_money' : 'cost_points'] > 0)
        : [];

    render(): React.ReactNode {
        const user = {...this.props.shopStore.data.user, cool_off: this.props.userStore.user.cool_off};
        return <div className="market-lootboxes">
            <div className="tabs js-tabs tabs--lots">
                <div className="tabs__content">
                    <div className="tabs__content-item">
                        <div className="tabs js-tabs tabs--secondary">
                            <div className="tabs__content">
                                <div className="tabs__content--filters tabs__content--filters_lootboxes">
                                    <InnerTabs
                                        queryParam="game"
                                        selectedTab={this.state.game}
                                        tabs={this.game_tabs}
                                        handleChange={this.handleChangeGame}
                                    />
                                    <div className="select-currency classical-select field__select">
                                        <SelectPicker
                                            id="currency_select"
                                            onChange={this.handleChangeCurrency}
                                            value={this.state.currency}
                                            collection={this.currencies}
                                        />
                                    </div>
                                </div>
                                <div className="tabs__content-item">
                                    <div className="market__lootboxes">
                                        <ShopItems
                                            currency={this.state.currency}
                                            user={user}
                                            lootboxes={this.getItemsWithGame()}
                                            noChunks
                                            afterBuy={updateShop}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default withRouter(inject('shopStore', 'userStore')(observer(ShopTableLootboxes)));
